import { HttpErrorResponse } from '@angular/common/http';
import {Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FabTableState, filterStateChange, process } from '@fabric/components/table-filter/data-query';
import { forkJoin, Observable, tap } from 'rxjs';
import { UserFunctionCode } from '../../constants/UserFunctionCode';
import { DeactivateGuardedComponent } from '../../interfaces/DeactivateGuardedComponent';
import { Balanza } from '../../models/Balanza';
import { Docks } from '../../models/Docks';
import { Estado } from '../../models/Estado';
import { PtoEmision } from '../../models/PtoEmision';
import { DocksService } from '../../services/docks.service';
import { NotificationService } from '../../services/notification.service';
import { PtoEmisionService } from '../../services/ptoEmision.service';
import { SecurityService } from '../../services/security.service';
import { SolicitanteService } from '../../services/solicitante.service';
import {
  FabDateFilterOperator,
  RemDateFilterComponent
} from '../../shared-components/table-filter/date-filter/date-filter.component';
import {RemNumberFilterComponent} from '../../shared-components/table-filter/number-filter/number-filter.component';
import {
  FabStringFilterOperator,
  RemStringFilterComponent
} from '../../shared-components/table-filter/string-filter/string-filter.component';

@Component({
    selector: 'app-dock-maintenance',
    templateUrl: './dock-maintenance.component.html',
    styleUrls: ['./dock-maintenance.component.scss']
})
export class DockMaintenanceComponent implements OnInit, DeactivateGuardedComponent {
    columnsToDisplay: string[] = ['dock', 'descCompDock', 'dunsDock', 'ptoEmision', 'balanza', 'fecCreacion', 'usrCreacion', 'fecModif', 'usrModif', 'estado', 'isEdit'];
    dataSource: MatTableDataSource<Docks> = new MatTableDataSource<Docks>();
    date = new Date();
    disablSaveButton = false;
    duplicates = false;
    allDuplicatesExist = false;
    balanzas: Balanza[] = [
        {value: 'N', valueType: 'N'},
        {value: 'S', valueType: 'S'}
    ];
    estados: Estado[] = [
        {value: true, valueType: 'Active'},
        {value: false, valueType: 'Inactive'}
    ];
    addedRow: Docks[] = [];
    editedRow: Docks[] = [];
    isLoading = false;
    operators: FabStringFilterOperator[] = ['contains'];
    dateOperators: FabDateFilterOperator[] = ['eq', 'gte', 'lte'];
    state: FabTableState = {
        skip: 0,
        take: 5,
        filter: [],
        sort: []
    };
    allDockData: Docks[] = [];
    allDocks: string[] = [];
    canEdit: boolean = true;
    duplicatesAddedPresent: boolean = false;
    selected = this.estados[1].valueType;
    user: string;
    ptoEmisions: PtoEmision[] = [];
    checkAllEmptyValues: boolean;
    selector: string;

    @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
        this.dataSource.paginator = paginator;
    }

    @ViewChild(MatSort) set matSort(sort: MatSort) {
        this.dataSource.sort = sort;
    }

    @ViewChildren('tableFilter') tableFilters: QueryList<RemStringFilterComponent | RemNumberFilterComponent | RemDateFilterComponent>;

    constructor(private docksService: DocksService,
                public dialog: MatDialog,
                private securityService: SecurityService,
                private notificationService: NotificationService,
                private solicitanteService: SolicitanteService,
                private readonly ptoEmisionService: PtoEmisionService,
                private elementRef: ElementRef) {

    }

    ngOnInit(): void {
        this.isLoading = true;
        forkJoin([this.getDocks(), this.getPtoEmisions()]).subscribe({
            complete: () => {
                this.isLoading = false;
            }
        });
        this.disablSaveButton = true;
        this.canEdit = this.securityService.can(UserFunctionCode.MAINTENANCE);
        this.user = this.securityService.LOGGED_USER.gmin;
        this.selector = this.elementRef.nativeElement.tagName.toLowerCase();
    }


    getDocks() {
        return this.docksService.getDocksInfo().pipe(
            tap((response) => {
                this.allDockData = response;
                this.allDocks = this.allDockData.map(a => a.dock);
                this.dataSource = new MatTableDataSource<Docks>(this.allDockData);
            })
        );


    }

    getPtoEmisions() {
        return this.ptoEmisionService.getAllPtoEmision().pipe(
            tap((res) => {
                this.ptoEmisions = res;
            })
        );
    }

    public clearAllFilters() {
        this.tableFilters.toArray().forEach((x) => x.clearFilter());
        this.getDocks();
    }


    public filterChange(event: any) {
        this.state.skip = 0;
        // @ts-ignore
        this.state.filter = filterStateChange(event, this.state.filter);
        this.fetchData();
    }

    private fetchData() {
        this.dataSource.data = process(this.allDockData, this.state)
    }

    addSelected() {
        const id = this.dataSource.data.length + 1;
        const newRow = {
            'id': id,
            'dock': '',
            'descCompDock': '',
            'dunsDock': '',
            'ptoEmision': '',
            'balanza': '',
            'fecCreacion': this.date,
            'usrCreacion': this.securityService.LOGGED_USER.gmin,
            'fecModif': new Date(0),
            'usrModif': '',
            'estado': true,
            added: true,
            edit: false,
            duplicateDock: false,
            duplicateExist: false
        };
        this.dataSource.data = [newRow, ...this.dataSource.data];
        this.disablSaveButton = true;
        this.addedRow.push(newRow);
        this.fetchData;
    }


    editRow(row: Docks) {
        row.edit = true;
    }


    cancelRow(row: Docks) {
        if (row.added === false) {
            this.removeRow(this.allDockData, row)
        }
        if (row.added === true) {
            this.dataSource.data = this.dataSource.data.filter((u: any) => u.id !== row.id);
            this.addedRow = this.addedRow.filter((u: any) => u.id !== row.id);
            row.dock = 'REMOVE';
        }
        if (row.edit === true) {
            this.editedRow = this.editedRow.filter((u: any) => u.dock !== row.dock);
            row.edit = false;
        }
        this.checkDuplicates(row);
        this.checkAdded(row);
        this.disableIfEmpty();
    }


    removeRow(data: any, row: any) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].id === row.id) {
                row.estado = true;
                row.edit = false;
                this.addedRow = this.addedRow.filter((u: any) => u.id !== row.id);
            }
        }
    }

    onSubmit() {
        this.isLoading = true;
        this.isLoading = false;
        if (this.editedRow.length > 0) {
            this.saveEditedRows();
        }
        if (this.editedRow.length === 0) {
            this.saveAddedRows();
        }
        return;
    }

    onChange(data: any) {
        if (data.added === true) {
            if (data.dock.length === 5) {
                this.checkDuplicates(data);
            }
            this.checkAdded(data);
        } else if (data.edit === true) {
            this.checkEditedRow(data);
            this.checkAdded(data);
            this.checkAllAdded();
            this.checkIfSolicitanteExist(data.dock, data.estado);
        }
        this.disableIfEmpty();
    }

    private checkAdded(data: any) {
        this.checkAddedDuplicates();
        if (this.checkEmptyFields(data) && this.checkDunsLengthOfValues()
            && this.duplicatesAddedPresent === false && this.checkAllEmptyValues && !this.allDuplicatesExist) {
            this.disablSaveButton = false;
        } else {
            this.disablSaveButton = true;
        }
        if (this.addedRow.length === 0 && this.editedRow.length === 0 ||
            this.addedRow.length === 0 && this.editedRow.length > 0) {
            this.disablSaveButton = false;
        }
    }

    public checkEmptyFields(data: any): boolean {
        return (data.id !== null &&
            (data.dock !== undefined && data.dock !== '') &&
            (data.descCompDock !== undefined && data.descCompDock !== '') &&
            (data.dunsDock !== undefined && data.dunsDock !== '') &&
            (data.ptoEmision !== undefined && data.ptoEmision !== '') &&
            (data.balanza !== undefined && data.balanza !== ''));
    }


    public checkEditedRow(data: any) {
        if (this.addedRow.length === 0 && this.editedRow.length > 0) {
            this.disablSaveButton = false;
        }
        if (data.estado === false) {
            this.editedRow.push(data);
        } else {
            this.editedRow = this.editedRow.filter((u: any) => u.dock !== data.dock);
            data.edit = false;
        }
    }


    public checkDunsLengthOfValues(): boolean {
        for (let j = 0; j < this.addedRow.length; j++) {
            if (this.addedRow[j].dunsDock.length < 9)
                return false;
        }
        return true;
    }


    @HostListener('window:beforeunload', ['$event'])
    defaultConfirmation($event: any) {
        if (!this.dirtyCheckAdded() || !this.dirtyCheckEdited()) {
            $event.returnValue(false);
        } else {
            $event.preventDefault();
        }
    }

    private dirtyCheckAdded(): boolean {
        for (let i = 0; i < this.addedRow.length; i++) {
            if (this.checkEmptyFields(this.addedRow[i])) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    }

    private dirtyCheckEdited(): boolean {
        if (this.editedRow.length === 0) {
            return true;
        } else {
            return false;
        }
    }


    canExit(): Observable<boolean> | Promise<boolean> | boolean {
        if (!this.dirtyCheckAdded() || !this.dirtyCheckEdited()) {
            return confirm('Usted tiene cambios no guardados. ¿Salir de la página de todos modos?');
        } else {
            return true;
        }
    }

    public checkIfSolicitanteExist(dock: string, estado: boolean) {
        let docks = new Array();
        this.solicitanteService.getByDock(dock).subscribe(data => {
            docks = data;
            if (docks.length > 0 && estado === false) {
                this.notificationService.open('Dock asociado al solicitante es inválido. Desactivar', 'warn');
            }
        });
    }

    private checkAddedDuplicates() {
        let addedRowDocks: string | string[] = [];
        for (let k = 0; k < this.addedRow.length; k++) {
            addedRowDocks.push(this.addedRow[k].dock.toLocaleUpperCase())
            const duplicates = addedRowDocks.filter((item, index) => index !== addedRowDocks.indexOf(item));
            if (duplicates.length > 0) {
                if (this.addedRow[k].duplicateDock === false) {
                    this.notificationService.open('Dock ya existe en New Record. Ingrese un Dock diferente', 'warn');
                    this.addedRow[k].duplicateDock = true;
                }
                this.duplicatesAddedPresent = true;
                this.addedRow[k].duplicateDock = true;
            } else {
                this.duplicatesAddedPresent = false;
                this.addedRow[k].duplicateDock = false;
            }
        }
        this.checkAllAdded();
    }

    private saveEditedRows() {
        if (this.editedRow.length > 0) {
            for (let i = 0; i < this.editedRow.length; i++) {
                if (this.editedRow[i].estado === true) {
                    this.editedRow = this.editedRow.filter((u: any) => u.dock !== this.editedRow[i].dock);
                } else {
                    this.editedRow[i].edit = false;
                    this.saveEdited(this.editedRow);
                }
                // @ts-ignore
                this.dataSource.data.find(item => item.id == this.editedRow[i].id).dock = this.editedRow[i].dock;

            }
        }
    }

    private saveAddedRows() {
        if (this.addedRow.length > 0) {
            for (let i = 0; i < this.addedRow.length; i++) {
                this.addedRow[i].usrCreacion = this.user
                this.addedRow[i].fecCreacion = this.date;

                this.dataSource.data.push(this.addedRow[i]);
            }
            this.saveAdded(this.addedRow);
        }
    }

    public saveAdded(dataDocks: any) {
        let errors: HttpErrorResponse[] = [];
        this.docksService.saveDocksInfo(dataDocks).subscribe({
            next: (response) => {
                this.notificationService.open('Rows saved.', 'success');
                for (let i = 0; i < dataDocks.length; i++) {
                    dataDocks[i].added = false;
                    dataDocks[i].edit = false
                    this.changeId(response);
                    this.addedRow = [];
                }
            },
            error: (error) => {
                errors.push(error);
                this.notificationService.open(this.notificationService.getErrorByCode(error.error.errorCode), "error")
            }
        })
    }

    public saveEdited(dataDocks: any) {
        for (let i = 0; i < dataDocks.length; i++) {
            this.docksService.updateDocks(dataDocks[i]).subscribe({
                next: (response) => {
                    if (response || this.addedRow.length > 0) {
                        if (this.addedRow.length > 0) {
                            this.saveAddedRows();
                        }
                        this.disableIfEmpty();
                        this.editedRow = [];
                        this.notificationService.open('Rows saved.', 'success');
                    }
                },
            })
        }
    }

    public checkAllAdded() {
        for (let i = 0; i < this.addedRow.length; i++) {
            if (this.addedRow[i].dock !== undefined && this.addedRow[i].dock !== '' &&
                this.addedRow[i].descCompDock !== undefined && this.addedRow[i].descCompDock !== '' &&
                this.addedRow[i].ptoEmision !== undefined && this.addedRow[i].ptoEmision !== '' &&
                this.addedRow[i].balanza !== undefined && this.addedRow[i].balanza !== '' &&
                this.addedRow[i].dunsDock.length === 9) {
                this.checkAllEmptyValues = true;
            } else {
                this.checkAllEmptyValues = false;
            }
        }
    }


    private changeId(response: any) {
        for (let i = 0; i < this.dataSource.data.length; i++) {
            for (let k = 0; k < response.length; k++) {
                if (response[k].dock === this.dataSource.data[i].dock) {
                    this.dataSource.data[i].id = response[k].id;
                }
            }
        }
    }

    private disableIfEmpty() {
        if (this.addedRow.length === 0 && this.editedRow.length === 0) {
            this.disablSaveButton = true;
        }
    }

    public checkDuplicates(dock: any) {
        let newDocks: string | string[] = []
        this.allDocks;
        this.addedRow;
        for (let k = 0; k < this.addedRow.length; k++) {
            newDocks.push(this.addedRow[k].dock)
            var duplicates = this.allDocks.filter((dock) => newDocks.includes(dock));
               if(duplicates.length > 0){
                   if(dock.duplicateExist === false){
                       this.notificationService.open('Dock ya existe en New Record. Ingrese un Dock diferente', 'warn');
                       this.addedRow[k].duplicateExist = true;
                   }
                   this.allDuplicatesExist = true
               }else{
                   this.addedRow[k].duplicateExist = false;
                   this.allDuplicatesExist = false;
               }
            }
        }
}
